import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

export function formatNumber(value: number, decimals = 0, relative = false): string {
    const prefix = relative && value > 0 ? '+' : ''
    const value_str =  value.toLocaleString('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })
    return `${prefix}${value_str}`
}

export function formatPercent(value: number, decimals = 0, relative = false): string {
    const prefix = relative && value > 0 ? '+' : ''
    const value_str = `${(value * 100).toLocaleString('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })}%`
    return `${prefix}${value_str}`
}

export function formatDate(value: Date|string|null, digit2?: boolean): string {
    if(value == null) {
        return "";
    }

    let d: Date;

    try {
        // Handle different date input formats
        if (value instanceof Date) {
            d = value;
        } else {
            // For string dates
            const dateStr = String(value);
            d = dayjs(dateStr).toDate();
        }

        // Check if date is valid
        if (isNaN(d.getTime())) {
            console.warn("Invalid date encountered:", value);
            return "Invalid date";
        }

        if(digit2) {
            return d.toLocaleDateString('de-DE', {'year': '2-digit', 'month': '2-digit', 'day': '2-digit'});
        } else {
            return d.toLocaleDateString('de-DE', {'year': 'numeric', 'month': '2-digit', 'day': '2-digit'});
        }
    } catch (error) {
        console.error("Error formatting date:", error, value);
        return "Invalid date";
    }
}

export function formatRelativeTime(value: Date): string {
    const now = new Date()
    const delta = Math.round((value.getTime() - now.getTime()) / 1000 / 60)
    // @ts-ignore
    const formatter = new Intl.RelativeTimeFormat('en');
    return formatter.format(delta, 'minute');
}
